export const LOCALES: Record<string, string> = {
  DE: "de-DE",
  EN: "en-GB",
  JA: "ja-JP",
}
